var $ = window.jQuery;
import Flickity from 'flickity';

export default function() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  function renderCustomFlickitySliders() {
    var customCarousel = document.querySelectorAll('.custom-carousel');
    var customFlkty;

    if (customCarousel !== null) {
      for (var i = 0; i < customCarousel.length; i++) {
        customFlkty = new Flickity(customCarousel[i]);
      }
    }
  }

  renderCustomFlickitySliders()

  ///
  function renderProductTileFlickitySliders() {
    var productSliders = document.querySelectorAll('.tile-carousel');
    var flkty

    if (productSliders.length) {
      for (var i = 0; i < productSliders.length; i++) {
        flkty = new Flickity(productSliders[i], {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          groupCells: true,
          autoPlay: 2000,
          pageDots: false,
          lazyLoad: 1
        });
      }
    }
  }

  renderProductTileFlickitySliders()

  $(document).on('facetwp-loaded', function () {
    if ($('.tile-carousel').length) {
      renderProductTileFlickitySliders()
    }
  })
}
